export const fileSizeLimits = {
  avatarBuInspector: 2000000, //2mb
  avatarBu: 1000000, //1mb
};
